
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"29","cy":"21.6","r":"2.2"}}),_c('circle',{attrs:{"cx":"33.6","cy":"31.1","r":"2.1"}}),_c('circle',{attrs:{"cx":"19.4","cy":"21.6","r":"2.2"}}),_c('path',{attrs:{"d":"M30 0C13.4 0 0 13.4 0 30s13.4 30 30 30 30-13.4 30-30S46.6 0 30 0zM19.6 37l-5.2 2.3 1.1-4.1C12 33 9.7 29.5 9.7 25.5c0-6.7 6.6-12.1 14.6-12.1 6.8 0 12.5 3.8 14.1 9h-1c-8 0-14.6 5.6-14.6 12.4 0 1 .1 1.9.4 2.8-1.2-.1-2.4-.3-3.6-.6zm26 5.8l.9 3.9-4.3-2.2c-1.5.5-3.2.8-4.9.8-7 0-12.7-4.7-12.7-10.5s5.7-10.5 12.7-10.5c7 0 12.7 4.7 12.7 10.5.1 3.2-1.6 6-4.4 8z"}}),_c('circle',{attrs:{"cx":"41.8","cy":"31.1","r":"2.1"}})])
          )
        }
      }
    